import { render, staticRenderFns } from "./RepaymentRequestsTab.vue?vue&type=template&id=6565130b&scoped=true"
import script from "./RepaymentRequestsTab.vue?vue&type=script&lang=js"
export * from "./RepaymentRequestsTab.vue?vue&type=script&lang=js"
import style0 from "./RepaymentRequestsTab.vue?vue&type=style&index=0&id=6565130b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565130b",
  null
  
)

export default component.exports